import { responseHandlerDefault } from "../utils/handler.util";
import axios from "./api";

export const getInfoEstimationYesterday = (samplingPoint?: number) => {
  return axios.get(`/estimation/estimationInfo24h/${samplingPoint}`).then(responseHandlerDefault);
};
